var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{ref:"country",attrs:{"value":_vm.value,"items":_vm.availableCountries,"rules":_vm.rules,"label":"Country","item-value":"code","item-text":"name","clearable":_vm.clearable,"hide-details":!_vm.rules.length,"data-cy":"countries"},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }